module.exports = __webpack_public_path__ + "static/media/analytical.05322790.svg";